<mat-toolbar class="flex items-center" color="primary">
  <img class="max-[500px]:size-16 logo-image px-1" alt="DRÄXLMAIER LOGO" src="img/drx-logo-white.svg" />
  <div class="flex items-center">
    <span class="max-[1030px]:text-xs max-[1300px]:text-sm text-wrap p-6">{{ "HEADER.PORTAL_TITLE" | translate }}
    </span>
  </div>
  <div class="max-[1025px]:hidden min-[1200px]:px-52 text-wrap">
    @for (item of getLinks(); track $index) {
    <button mat-button class="max-[1025px]:invisible" [routerLink]="[item.link]" title="{{ item.text }}">
      {{ item.text }}
    </button>
    }
  </div>
  <div class="ms-auto grid grid-flow-col auto-cols-min">
    <div class="ms-auto items-center">
      <span>
        @if (isLoggedIn$ | async) {
        <button mat-icon-button (click)="logout()">
          <mat-icon>logout</mat-icon>
        </button>
        } @else {
        <button mat-icon-button (click)="login()">
          <mat-icon>login</mat-icon>
        </button>
        }
      </span>
    </div>
    <div class="ms-auto items-center min-[1025px]:hidden">
      <span>
        <button mat-icon-button (click)="toggleMenu()">
          <mat-icon>menu</mat-icon>
        </button>
      </span>
    </div>
  </div>
</mat-toolbar>

<div class=" flex flex-col px-4 pb-4 min-[1025px]:hidden" *ngIf="triggerMenu">
  <div class="menu-container border-b-2 divide-y-2 ">
    @for (item of getLinks(); track $index) {
    <div>
      <button mat-button class="menu-buttons text-wrap px-2" [routerLink]="[item.link]" title="{{ item.text }}">
        {{ item.text }}
      </button>
    </div>
    }
  </div>
</div>